interface MessageMediaProps {
  contentType: string;
  contentUrl: string;
}

export function MessageMedia({ contentType, contentUrl }: MessageMediaProps) {
  switch (contentType) {
    case "image":
      return (
        <img
          src={contentUrl}
          alt="Imagem"
          className="mb-1 max-h-64 rounded-md object-cover"
          loading="lazy"
        />
      );
    case "audio":
      return <audio src={contentUrl} controls className="mb-1 w-full" />;
    case "video":
      return (
        <video src={contentUrl} controls className="mb-1 max-h-64 rounded-md" />
      );
    case "document":
    case "file":
      return (
        <a
          href={contentUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mb-1 flex items-center gap-2 rounded-md bg-background/50 px-3 py-2 text-sm underline"
        >
          📎 Download arquivo
        </a>
      );
    default:
      return null;
  }
}
